import ChangePassword from './ChangePassword.jsx';

export default ChangePassword;
